import { render, staticRenderFns } from "./PostFeature.vue?vue&type=template&id=1514b2a1&"
import script from "./PostFeature.vue?vue&type=script&lang=js&"
export * from "./PostFeature.vue?vue&type=script&lang=js&"
import style0 from "./PostFeature.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports